/* eslint-disable react-hooks/exhaustive-deps */
// react
import {
  Container,
  Row,
  Col,
  Card,
  Collapse,
  Button,
  Form,
  Table,
} from "react-bootstrap"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import dayjs from "dayjs"

// wijmo

import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"

// fortawasome
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// other
import { AppDispatch } from "../../../.."
import gridPageHelper from "../../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../../ts/helpers/pageHelper"
import Decimal from "decimal.js"

// Kairos
import AlertComponent from "../../../../components/AlertComponent"
import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../../constant"
import { showInfoToast } from "../../../../components/CustomToast"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import DisplaySearchConditionLabel from "../../../../components/DisplaySearchConditionLabel"
import TextInput from "../../../../components/InputWrapper/TextInput"
import TextAreaInput from "../../../../components/InputWrapper/TextAreaInput"
import Spinner from "../../../../components/Spinner"
import ComboBox from "../../../../components/ComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../../type/wijmoComponents"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { RootState } from "../../../../globalStore/rootreducer"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
  setInfoAlerts,
} from "../../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../../globalStore/progressStore"
import {
  TPaymentRegisterListGetReq,
  TPaymentRegisterListGetRes,
  TPaymentRegisterListPutReq,
  TPaymentRegisterZyutyuHaisya,
  // TPaymentRegisterSekisaiHin,
  TPaymentRegisterListPutReqValidate,
} from "../../../../service/billing/payment/TPayment"
import PaymentListService from "../../../../service/billing/payment/paymentListService"
import {
  車輌Bindings,
  品名Bindings,
  積卸地Bindings,
  支払額Bindings,
  請求額Bindings,
} from "./PaymentListConstant"
import { TApiResponse } from "../../../../service/TApiResponse"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import KubunService from "../../../../service/master/kubun/kubunService"
import util from "../../../../ts/util"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import { TPaymentRegisterListPutReqSchema } from "../../../../service/billing/payment/paymentListSchema"
import {
  paymentListExcelFormat,
  paymentListPdfFormat,
} from "../../../../ts/util/exportUtil"

export type T支払明細入力GridItem = TPaymentRegisterListGetRes

// 検索条件と表示用検索条件
type TOmitDisplay = "支払額確認区分コード"

type T表示用検索条件 = Omit<TPaymentRegisterListGetReq, TOmitDisplay> &
  Partial<{
    支払額確認区分?: string
  }>

// 明細データの集計用
export type summaryRow = {
  支払合計ID: number
  受注配車ID: number
  積載品ID: number
  支払運送料: number
  支払付帯料: number
  支払高速料: number
  支払合計額: number
}

/**
 * 支払明細一覧
 * @returns
 */
const PaymentList = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : 0

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )
  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //TODO:ページ名称確定必須
  let gridId = "PaymentList_GridId"

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        請求額合計: (item: T支払明細入力GridItem) =>
          new Decimal(item.請求運送料 ?? 0)
            .plus(item.請求付帯料 ?? 0)
            .plus(item.請求高速料 ?? 0)
            .toNumber(),
        支払額合計: (item: T支払明細入力GridItem) =>
          new Decimal(item.支払運送料 ?? 0)
            .plus(item.支払付帯料 ?? 0)
            .plus(item.支払高速料 ?? 0)
            .toNumber(),
      },
    })

  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        支払合計額: (item: TPaymentRegisterListGetRes) =>
          new Decimal(item.支払高速料 ?? 0)
            .plus(item.支払運送料 ?? 0)
            .plus(item.支払付帯料 ?? 0)
            .toNumber(),
      },
    })
  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    // handler付与
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)
    grid.cellEditEnded.addHandler(cellEditEnded)
    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjGrid.FlexGrid) => {
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (積卸地Bindings.includes(c.binding)) {
          setHeaderText = "積卸地"
        } else if (品名Bindings.includes(c.binding)) {
          setHeaderText = "品名"
        } else if (車輌Bindings.includes(c.binding)) {
          setHeaderText = "車輌"
        } else if (請求額Bindings.includes(c.binding)) {
          setHeaderText = "請求額"
        } else if (支払額Bindings.includes(c.binding)) {
          setHeaderText = "支払額"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      let setHeaderTextAlign = ""
      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
        if (r === 0) {
          if (積卸地Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (品名Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (車輌Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (請求額Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (支払額Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          }
        }
        cell.style.textAlign = setHeaderTextAlign
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    // 明細の集計値を算出
    const sumRow: summaryRow = {
      支払合計ID: 0,
      受注配車ID: 0,
      積載品ID: 0,
      支払運送料: 0,
      支払付帯料: 0,
      支払高速料: 0,
      支払合計額: 0,
    }

    let 支払運送料 = 0
    let 支払付帯料 = 0
    let 支払高速料 = 0

    s.collectionView.sourceCollection.forEach((row: T支払明細入力GridItem) => {
      支払運送料 = row.支払運送料 ? row.支払運送料 : 0
      支払付帯料 = row.支払付帯料 ? row.支払付帯料 : 0
      支払高速料 = row.支払高速料 ? row.支払高速料 : 0

      sumRow.支払運送料 += 支払運送料
      sumRow.支払付帯料 += 支払付帯料
      sumRow.支払高速料 += 支払高速料
      sumRow.支払合計額 += 支払運送料 + 支払付帯料 + 支払高速料
    })

    const sumData: T支払明細入力GridItem[] = [sumRow]

    setSummaryGridData({
      data: createSummaryCollectionView(sumData, pageSize),
    })
  }

  const cellEditEnding = (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellEditEndingEventArgs
  ) => {
    // キャンセルの場合処理しない

    if (e.cancel) return
  }

  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {}

  /**
   * 検索
   */
  const search = async (searchCondition?: TPaymentRegisterListGetReq) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TPaymentRegisterListGetReq | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const service = new PaymentListService()

      const res = await service.getList(currentSearchCondition)

      res.data.forEach((row) => {
        if (row.受注伝票番号 != null) {
          row.受注伝票番号 = row.受注伝票番号 + "-" + row.受注枝番
        }
      })

      setSearchResult([...res.data])
      // 支払合計テーブル更新用
      set支払合計更新日時(
        res.data[0].支払合計更新日時 ? res.data[0].支払合計更新日時 : ""
      )
      set備考(res.data[0].支払合計備考 ? res.data[0].支払合計備考 : "")

      if (isSetInitSearchCondition) {
        if (res && res.data.length <= 0) {
          dispatch(setInfoAlerts(["表示対象となる支払データが存在しません"]))
          return
        }
        // 検索条件の初期設定
        set支払年月(res.data[0].支払年月 ? res.data[0].支払年月 : "")
        set支払先コード(
          res.data[0].支払先コード ? res.data[0].支払先コード : ""
        )
        set支払先名(res.data[0].支払先名 ? res.data[0].支払先名 : "")
      }
      setIsSetInitSearchCondition(false)
    } catch (error) {
      dispatch(
        setInfoAlerts(["検索条件に該当するデータを取得できませんでした"])
      )
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TPaymentRegisterListGetReq => {
    return {
      支払合計ID: id,
      支払額確認区分コード: 支払額確認区分コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TPaymentRegisterListGetReq
  ): T表示用検索条件 | undefined => {
    return {
      支払額確認区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.支払額確認区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
      )?.名称1,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装
    clearError()

    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema = TPaymentRegisterListPutReqSchema
    const data: TPaymentRegisterListPutReqValidate = {
      支払合計備考: 備考 ?? "",
      支払処理状態区分コード: 支払処理状態区分コード ?? null,
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors

      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        dispatch(
          setWarningAlerts([
            ...errors
              .filter((e) => e.message != null)
              .map((e) => e.message ?? ""),
          ])
        )
      }
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid備考(errorProperties.includes("備考"))
    setIsInvalid支払処理状態区分コード(
      errorProperties.includes("支払処理状態区分コード")
    )
  }

  const clearError = () => {
    dispatch(clearAlert())

    setIsInvalid備考(false)
    setIsInvalid支払処理状態区分コード(false)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認

      const zyutyuHaisyaList: TPaymentRegisterZyutyuHaisya[] = []
      // const sekisaiHinList: TPaymentRegisterSekisaiHin[] = []

      flexGrid?.collectionView.sourceCollection.forEach(
        (row: TPaymentRegisterListGetRes) => {
          // 受注配車情報
          let zyutyuHaisyaRow: TPaymentRegisterZyutyuHaisya = {
            受注配車ID: row.受注配車ID,
            支払区分コード: row.支払区分コード,
            支払計上日: row.支払計上日,
            支払運送料課税区分コード: row.支払運送料課税区分コード,
            支払運送料: row.支払運送料 ?? 0,
            支払付帯料課税区分コード: row.支払付帯料課税区分コード,
            支払付帯料: row.支払付帯料 ?? 0,
            支払高速料: row.支払高速料 ?? 0,
            支払備考: row.支払備考,
            支払額確認区分コード: row.支払額確認区分コード,
            更新日時: row.受注配車更新日時,
          }
          if (!zyutyuHaisyaList.find((z) => z.受注配車ID === row.受注配車ID)) {
            zyutyuHaisyaList.push(zyutyuHaisyaRow)
          }
        }
      )

      const data: TPaymentRegisterListPutReq = {
        受注配車情報リスト: zyutyuHaisyaList,
        // 積載品情報リスト: sekisaiHinList,
        支払合計ID: id,
        支払処理状態区分コード: 支払処理状態区分コード,
        備考: 備考,
        更新日時: 支払合計更新日時 ?? undefined,
      }

      const service = new PaymentListService()

      let res: TApiResponse<boolean>
      res = await service.put(id, data)
      dispatch(setAlerts(res))
      if (res) {
        // 更新後の再検索
        search().finally(() => {
          dispatch(画面ロック解除())
        })
        isPrompt.current = false
        showInfoToast(`支払明細の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // サマリ用グリッド
  const [summaryFlexGrid, setSummaryFlexGrid] = useState<wjGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  // 画面共通
  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<T表示用検索条件>()

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [searchResult, setSearchResult] = useState<T支払明細入力GridItem[]>()

  // ヘッダ部分
  const [支払年月, set支払年月] = useState<string | null | undefined>(翌営業日)
  const [支払先コード, set支払先コード] = useState<string | undefined>()
  const [支払先名, set支払先名] = useState<string>()
  const [isSetInitSearchCondition, setIsSetInitSearchCondition] = useState(true)

  // 支払額確認
  const [支払額確認区分コード, set支払額確認区分コード] = useState<
    string | null
  >()
  const [支払額確認区分ComboBox, set支払額確認区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [支払額確認区分isLoadEnded, set支払額確認区分isLoadEnded] =
    useState<boolean>(false)

  const [備考, set備考] = useState<string>("")

  //区分系
  const [支払区分DataMap, set支払区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()
  const [支払額確認区分DataMap, set支払額確認区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()

  // 更新 処理用
  const [支払合計更新日時, set支払合計更新日時] = useState<string | null>()
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 支払処理状態
  const [支払処理状態区分コード, set支払処理状態区分コード] = useState<
    string | null
  >()

  const [支払処理状態区分ComboBox, set支払処理状態区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [支払処理状態区分IsLoadEnded, set支払処理状態区分IsLoadEnded] =
    useState<boolean>(false)

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  //　エラー表示用フラグ
  const [isInvalid備考, setIsInvalid備考] = useState<boolean>(false)
  const [isInvalid支払処理状態区分コード, setIsInvalid支払処理状態区分コード] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    //区分値の確保
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      set支払区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.請求区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set支払額確認区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
          ),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時は常に検索を行う
      // 検索
      search().finally(() => {
        dispatch(画面ロック解除())
      })

      if (location.search !== "") {
        // リストア中フラグON
        setIsRestoreSearching(true)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    if (searchResult == null) return
    flexGrid?.refresh()
    setGridData({ data: createCollectionView(searchResult, pageSize) })

    // 明細の集計値を算出
    const sumRow: summaryRow = {
      支払合計ID: 0,
      受注配車ID: 0,
      積載品ID: 0,
      支払運送料: 0,
      支払付帯料: 0,
      支払高速料: 0,
      支払合計額: 0,
    }

    let 支払運送料 = 0
    let 支払付帯料 = 0
    let 支払高速料 = 0

    searchResult.forEach((row) => {
      支払運送料 = row.支払運送料 ? row.支払運送料 : 0
      支払付帯料 = row.支払付帯料 ? row.支払付帯料 : 0
      支払高速料 = row.支払高速料 ? row.支払高速料 : 0

      sumRow.支払運送料 += 支払運送料
      sumRow.支払付帯料 += 支払付帯料
      sumRow.支払高速料 += 支払高速料
      sumRow.支払合計額 += 支払運送料 + 支払付帯料 + 支払高速料
    })

    const sumData: T支払明細入力GridItem[] = [sumRow]

    setSummaryGridData({
      data: createSummaryCollectionView(sumData, pageSize),
    })
  }, [searchResult])

  useEffect(() => {
    if (searchResult == null) return

    if (支払処理状態区分コード === "2" || 支払処理状態区分コード === "3") {
      //「支払処理状態区分：確定／送付済」の場合、全明細を「確認済」とする
      searchResult?.forEach((row) => {
        row.支払額確認区分コード = "1"
      })
      flexGrid?.refresh()
    }
  }, [支払処理状態区分コード])

  useEffect(() => {
    if (支払処理状態区分IsLoadEnded) {
      if (searchResult != null && searchResult.length > 0) {
        // 支払処理状態区分の初期選択値を設定
        set支払処理状態区分コード(searchResult[0].支払処理状態区分コード)
      } else {
        set支払処理状態区分コード("")
      }
    }
  }, [支払処理状態区分IsLoadEnded, searchResult])

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    flexGrid?.formatItem.removeHandler(formatItem)
    flexGrid?.formatItem.addHandler(formatItem)
    flexGrid?.beginningEdit.removeHandler(beginningEdit)
    flexGrid?.beginningEdit.addHandler(beginningEdit)
    flexGrid?.cellEditEnding.removeHandler(cellEditEnding)
    flexGrid?.cellEditEnding.addHandler(cellEditEnding)
    flexGrid?.cellEditEnded.removeHandler(cellEditEnded)
    flexGrid?.cellEditEnded.addHandler(cellEditEnded)
  }, [flexGrid, summaryFlexGrid])

  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">支払明細一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-90rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body id="collapse-search-card-body">
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <Table className="search-table">
                            <tbody>
                              <tr>
                                <td>
                                  <div className="input-group">
                                    <div className="w-6rem">
                                      <TextInput
                                        id="支払年月"
                                        name="支払年月"
                                        placeholder="支払年月"
                                        value={util.date.format(
                                          支払年月,
                                          "YYYY/MM"
                                        )}
                                        setValue={set支払年月}
                                        isReadOnly={true}
                                        tabIndex={-1}
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      placeholder="支払先CD"
                                      id="支払先コード"
                                      name="支払先コード"
                                      value={支払先コード}
                                      isReadOnly={true}
                                      style={{ width: "6rem" }}
                                      tabIndex={-1}
                                      setValue={set支払先コード}
                                    />
                                    <TextInput
                                      placeholder="支払先名"
                                      id="支払先名"
                                      name="支払先名"
                                      value={支払先名}
                                      setValue={set支払先名}
                                      maxLength={100}
                                      isReadOnly={true}
                                      tabIndex={-1}
                                      style={{ width: "25rem" }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="w-13rem">
                                    <ComboBox.Kubun
                                      placeholder="支払額確認"
                                      分類コード={
                                        区分分類コード.受注配車_請求支払
                                          .請求支払確認区分
                                      }
                                      itemsSource={区分ItemSource}
                                      isLoadEnded={支払額確認区分isLoadEnded}
                                      isAllSelect={true}
                                      isRequired={false}
                                      setIsLoadEnded={
                                        set支払額確認区分isLoadEnded
                                      }
                                      selectedValue={支払額確認区分コード}
                                      setSelectedValue={(v) => {
                                        set支払額確認区分コード(v)
                                      }}
                                      ComboBox={支払額確認区分ComboBox}
                                      setComboBox={
                                        set支払額確認区分ComboBox
                                      }></ComboBox.Kubun>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Button
                                    type="submit"
                                    disabled={isSearching}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      e.preventDefault()
                                      search()
                                    }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                    検索
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col xs={12}>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                {/* 合計欄 */}
                <div className="row">
                  <div className="col">
                    <FlexGridOuter
                      flexGrid={summaryFlexGrid}
                      gridConstantProperties={
                        CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL
                      }
                      setFlexGrid={setSummaryFlexGrid}
                      gridData={summaryGridData}
                      setGridData={setSummaryGridData}
                      pageNumber={pageNumber}
                      gridId={`${gridId}_1`}
                      isRestoreSearching={isRestoreSearching}
                      setIsRestoreSearching={setIsRestoreSearching}
                      gridInitialized={gridInitialized}
                      setGridInitialized={setGridInitialized}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      isShowGridFooter={false}
                      isShowGridRowPickupButton={false}
                      hasFilter={false}>
                      <wjrGrid.FlexGridColumn
                        binding="支払運送料"
                        cssClass="number-col"
                        cssClassAll={"read-only-cell"}
                        width={128}
                        header="運送料"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="支払付帯料"
                        cssClass="number-col"
                        width={128}
                        cssClassAll={"read-only-cell"}
                        header="付帯料"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="支払高速料"
                        cssClass="number-col"
                        width={128}
                        cssClassAll={"read-only-cell"}
                        header="高速料"></wjrGrid.FlexGridColumn>
                      <wjrGrid.FlexGridColumn
                        binding="支払合計額"
                        cssClass="number-col"
                        width={128}
                        header="合計額"
                        cssClassAll={"read-only-cell"}></wjrGrid.FlexGridColumn>
                    </FlexGridOuter>
                  </div>
                  <div className="col">
                    <div className="w-12rem">
                      <ComboBox.Kubun
                        placeholder="支払処理状態"
                        分類コード={
                          区分分類コード.受注配車_請求支払.請求支払処理状態区分
                        }
                        isLoadEnded={支払処理状態区分IsLoadEnded}
                        setIsLoadEnded={set支払処理状態区分IsLoadEnded}
                        isAllSelect={false}
                        itemsSource={区分ItemSource}
                        selectedValue={支払処理状態区分コード}
                        setSelectedValue={set支払処理状態区分コード}
                        ComboBox={支払処理状態区分ComboBox}
                        setComboBox={set支払処理状態区分ComboBox}
                        className={
                          isInvalid支払処理状態区分コード ? "is-error" : ""
                        }></ComboBox.Kubun>
                    </div>
                  </div>
                </div>

                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  gridId={`${gridId}_2`}
                  isRestoreSearching={isRestoreSearching}
                  isEnablePageSize={"hidden"}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  excelFormatItem={paymentListExcelFormat}
                  pdfFormatItem={paymentListPdfFormat}
                  gridProperties={{
                    frozenColumns: 1,
                    isReadOnly: false,
                    allowMerging: wjGrid.AllowMerging.ColumnHeaders,
                    headersVisibility: wjGrid.HeadersVisibility.All,
                    keyActionTab: wjGrid.KeyAction.CycleOut,
                  }}
                  headerComponent={<></>}>
                  <wjrGrid.FlexGridColumn
                    binding="受注伝票番号"
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    width={110}
                    header="受注No"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="積日"
                    width={90}
                    cssClass={"read-only-cell"}
                    header="積日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<T支払明細入力GridItem>
                      ) => {
                        let dDate = ""
                        if (context.item.積日)
                          dDate = dayjs(context.item.積日).format("MM/DD")
                        return (
                          <>
                            <span>{dDate}</span>
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="卸日"
                    width={90}
                    cssClass={"read-only-cell"}
                    header="卸日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<T支払明細入力GridItem>
                      ) => {
                        let dDate = ""
                        if (context.item.卸日)
                          dDate = dayjs(context.item.卸日).format("MM/DD")
                        return (
                          <>
                            <span>{dDate}</span>
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  {/* 車輌 */}
                  <wjrGrid.FlexGridColumn
                    binding="車番"
                    width={85}
                    cssClass={"read-only-cell"}
                    header="車番"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="トレーラ車番"
                    width={85}
                    cssClass={"read-only-cell"}
                    header="トレーラ"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員名"
                    width={128}
                    cssClass={"read-only-cell"}
                    header="乗務員"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運行部所名"
                    width={128}
                    cssClass={"read-only-cell"}
                    header="運行部所"></wjrGrid.FlexGridColumn>
                  {/* 積卸地 */}
                  <wjrGrid.FlexGridColumn
                    binding="積場社名"
                    width={150}
                    cssClass={"read-only-cell"}
                    header="積場社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="積場地名"
                    width={150}
                    cssClass={"read-only-cell"}
                    header="積場地名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="卸場社名"
                    width={150}
                    cssClass={"read-only-cell"}
                    header="卸場社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="卸場地名"
                    width={150}
                    cssClass={"read-only-cell"}
                    header="卸場地名"></wjrGrid.FlexGridColumn>
                  {/* 品名 */}
                  <wjrGrid.FlexGridColumn
                    binding="品コード"
                    width={80}
                    cssClass={"read-only-cell"}
                    header="品CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="品名"
                    width={150}
                    cssClass={"read-only-cell"}
                    header="品名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="数量"
                    width={80}
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    cssClassAll={"read-only-cell"}
                    format={"N3"}
                    header="数量"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="単位区分名称"
                    width={64}
                    cssClass={"read-only-cell"}
                    header="単位"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主依頼番号"
                    width={128}
                    cssClass={"read-only-cell"}
                    header="荷主依頼No"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="コンテナNO"
                    width={128}
                    cssClass={"read-only-cell"}
                    header="コンテナNo"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払区分コード"
                    dataMap={支払区分DataMap}
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    header="請求区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="単価"
                    isReadOnly={true}
                    cssClassAll={"read-only-cell"}
                    dataType={wjCore.DataType.Number}
                    header="請求単価"></wjrGrid.FlexGridColumn>
                  {/* 請求額 */}
                  <wjrGrid.FlexGridColumn
                    binding="請求運送料課税区分名称"
                    width={80}
                    cssClassAll={"read-only-cell"}
                    header="非/課"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求運送料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    cssClassAll={"read-only-cell"}
                    isReadOnly={true}
                    header="請求運送料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求付帯料課税区分名称"
                    width={80}
                    cssClassAll={"read-only-cell"}
                    header="非/課"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求付帯料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    cssClassAll={"read-only-cell"}
                    isReadOnly={true}
                    header="請求付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求高速料税込区分名称"
                    width={80}
                    cssClass={"read-only-cell"}
                    header="込/別"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求高速料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    cssClassAll={"read-only-cell"}
                    isReadOnly={true}
                    header="請求高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求額合計"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    cssClassAll={"read-only-cell"}
                    isReadOnly={true}
                    header="請求額合計"></wjrGrid.FlexGridColumn>
                  {/* 支払額 */}
                  <wjrGrid.FlexGridColumn
                    binding="支払運送料課税区分コード"
                    width={80}
                    dataMap={課税区分DataMap}
                    header="非/課"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払運送料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    header="支払運送料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払付帯料課税区分コード"
                    width={80}
                    dataMap={課税区分DataMap}
                    header="非/課"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払付帯料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    header="支払付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払高速料税込区分名称"
                    width={80}
                    cssClass={"read-only-cell"}
                    header="込/別"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払高速料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    header="支払高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払額合計"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    cssClassAll={"read-only-cell"}
                    isReadOnly={true}
                    header="支払額合計"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払備考"
                    width={200}
                    header="支払備考"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払計上日"
                    editor={
                      new wjcInput.InputDate(document.createElement("div"), {
                        format: "yyyyMMdd",
                      })
                    }
                    format={"d"}
                    header="支払計上日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<T支払明細入力GridItem>
                      ) => {
                        let dDate = ""
                        if (context.item.支払計上日)
                          dDate = dayjs(context.item.支払計上日).format(
                            "YYYY/MM/DD"
                          )

                        return (
                          <>
                            <span>{dDate}</span>
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払額確認区分コード"
                    width={128}
                    dataMap={支払額確認区分DataMap}
                    header="支払額確認"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* ヘッダーフッター入力用・登録ボタン用カード */}
            <Card>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">備考</th>
                              <td>
                                <TextAreaInput
                                  style={{ width: "60rem" }}
                                  id="備考"
                                  name="備考"
                                  value={備考}
                                  setValue={set備考}
                                  placeholder="備考"
                                  className={isInvalid備考 ? "is-error" : ""}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {`更新`}
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default PaymentList
